<div class="userInfoRow" style="height:100%">

	<div class="row g-0" style="border-bottom: 1px solid #c07373; padding: 8px;">
		<div class="col-2">
			<img (click)="setLanguage(2)" src="https://tenant.mycapx.com/jp.svg" class="flagIcon" alt="Japanese Flag" title="{{contentStrings['LanguageJapanese'][language]}}"/>
		</div>
		<div class="col-2">
			<img (click)="setLanguage(1)" src="https://tenant.mycapx.com/us.svg" class="flagIcon" alt="US Flag" title="{{contentStrings['LanguageEnglish'][language]}}"/>
		</div>
		<div class="col-md-8">

		</div>
	</div>
	

	<div class="row g-0" style="border-bottom: 1px solid #c07373; padding: 8px;">
		<div class="col-12">
			{{ tenant?.Email }}
		</div>

		<div class="col-12">
			{{contentStrings['LastLogin'][language]}}: {{ tenant?.Last_login | date:'short' }}
		</div>

		<div *ngIf="tenant && tenant.Tenant_id > 0" class="col-12">

			<div class="logoutBtn" (click)="logout()">
				<i class="fa fa-sign-out"></i>
				<span style="cursor: pointer;" >{{contentStrings['Logout'][language]}}</span>
			</div>

		</div>
	</div>

	<div class="row g-0">
		<div class="col-12 navButton" routerLink="/home" routerLinkActive="active">
			<a class="nav-link d-inline-block" >{{contentStrings['Home'][language]}}</a>
		</div>
		<div class="col-12 navButton" routerLink="/community-calendar" routerLinkActive="active">
			<a class="nav-link d-inline-block" >{{contentStrings['EventCalendar'][language]}}</a>
		</div>
		<div class="col-12 navButton" routerLink="/pay-my-rent" routerLinkActive="active">
			<a class="nav-link d-inline-block" >{{contentStrings['PayMyRent'][language]}}</a>
		</div>
		<div class="col-12 navButton" routerLink="/my-work-orders" routerLinkActive="active">
			<a class="nav-link d-inline-block" >{{contentStrings['MyWorkOrders'][language]}}</a>
		</div>
		<div class="col-12 navButton" routerLink="/request-work-orders" routerLinkActive="active">
			<a class="nav-link d-inline-block" >{{contentStrings['SharedDocuments'][language]}}</a>
		</div>
		<div class="col-12 navButton" routerLink="/request-work-orders" routerLinkActive="active">
			<a class="nav-link d-inline-block" >{{contentStrings['Insurance'][language]}}</a>
		</div>
		<div class="col-12 navButton" routerLink="/app-property-details-page" routerLinkActive="active">
			<a class="nav-link d-inline-block" >{{contentStrings['PropertyDetails'][language]}}</a>
		</div>
		<div class="col-12 navButton" routerLink="/request-work-orders" routerLinkActive="active">
			<a class="nav-link d-inline-block" >{{contentStrings['AccountProfile'][language]}}</a>
		</div>
		<div class="col-12 navButton"  routerLink="/request-work-orders" routerLinkActive="active">
			<a class="nav-link d-inline-block">{{contentStrings['HelpDesk'][language]}}</a>
		</div>
			<div class="col-12 navButton" routerLink="/request-work-orders" routerLinkActive="active">
			<a class="nav-link d-inline-block" >{{contentStrings['ContactUs'][language]}}</a>
		</div>

	</div>

	<div class="row g-0" style="text-align: center; font-size: .8rem; color: #888;flex: 99; flex-direction: column;justify-content: flex-end;">
		<div class="copywr" style="padding: 12px;">
			&copy; {{year}} MyCapX. All rights reserved.
		</div>
	</div>


</div>